import PriorityIcon from "@coworker/reusable/svg/priority-exclamation-sign.svg?react";

export function Priority() {
  return <PriorityIcon />;
}
